import React, {Component} from 'react';
import CBaseComponent from '@/components/CBaseComponent'
import './index.scss'
import {Card, Modal, Button, message,Empty} from "antd";
import { compose} from "redux";
import { withRouter} from 'react-router-dom'
import { submitdata,selectIndex } from "@/servers/commonApi";
import CTable from '@/components/CTable'

@CBaseComponent
class Home extends Component{
    constructor(props) {
        super(props);
        this.showModal = this.showModal.bind(this)
        this.handleCanceldialog = this.handleCanceldialog.bind(this)
        this.downloads = this.downloads.bind(this)
    }


    state = {
        data: null,
        loading: false,
        isModalVisible: false,
        status: false,
        step:'',
        fileslist:[],
        newslist:[],
        result:[],
        columns: [
            {
                key: 'name',
                dataIndex: 'name',
                title: '项目内容',
                align:'center'
            },
            {
                key: 'text',
                dataIndex: 'text',
                title: '文本信息',
                align:'center'
            },
            {
                key: 'filecount',
                dataIndex: 'filecount',
                title: '上传文件个数',
                align:'center'
            },
        ],
    };

    showModal(data){
        this.setState({
            isModalVisible:true
        })
        var newStr = decodeURI(data.content).replaceAll("++++","\n");
        this.setState({
            title:data.title,
            name: data.postedby,
            time:data.postedtime,
            content:newStr
        })
    }

    handleCanceldialog(){
        this.setState({
            title: '',
            content:'',
            isModalVisible: false
        })
    }

    downloads(data){
        window.open(data,"_blank");
    }

    handleSubmit(){
        Modal.confirm({
            content: '确认提交?',
            okText: '确认',
            cancelText: '取消',
            onOk:()=>{
                 submitdata().then(res=>{
                    if (res.statecode === 0) {
                        message.success('提交成功');
                        this.selectdata()
                        this.setState({
                            status: true
                        })
                    } else {
                        message.error(res.statemessage);
                    }
                })
            }
        })
    }

    componentWillReceiveProps(nextProps){

    }
    showModal = (data) => {
        this.setState({
            isModalVisible:true
        })
        var newStr = decodeURI(data.content).replaceAll("++++","\n");
        this.setState({
            title:data.title,
            name: data.postedby,
            time:data.postedtime,
            content:newStr
        })
    };

    handleCanceldialog(){
        this.setState({
            title: '',
            content:'',
            isModalVisible: false
        })
    }


     selectdata(){
        this.setState({
            loading:true
        })
        selectIndex().then(res=>{
            if (res.statecode === 0) {
                this.setState({
                    result:res.records[0].datalist,
                    fileslist:res.records[0].filelist,
                    newslist:res.records[0].bulletinlist,
                    loading:false,
                })
            } else {
                message.error(res.statemessage);
            }
        })
    }

    componentDidMount(){
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.setState({
            step:userInfo[0].step
        })
        this.selectdata()
    }


    render(){
        return (
            <main style={{textAlign:'left'}} className='containerblock'>
                <div className='contents'>
                    <div className='zhibiao'>
                        <span>当前进展：{this.state.step}</span>
                    </div>
                    <div className='indextable'>
                        <CTable ref='historyRecordDeleteUserList' checked={false} loading={false} columns={this.state.columns} dataSource={this.state.result}>
                        </CTable>
                    </div>
                    <div className='system-info'>
                        <div className='system-tz'>
                            <Card title="系统公告" bordered={false} style={{ width: '100%' }}>
                                {
                                    this.state.newslist.length === 0? <Empty></Empty>:
                                        this.state.newslist.map(item=>{
                                            return <div onClick={()=>{this.showModal(item)}} className='new-block'>
                                                {
                                                    Number(item.top > 1000) ?
                                                        <span className='important'>{item.title}</span>:
                                                        <span>{item.title}</span>
                                                }
                                                <span>{item.postedtime}</span>
                                                <span className='circle'>></span>
                                            </div>
                                        })
                                }

                            </Card>
                        </div>
                        <div className='system-file'>
                            <Card title="文件中心" bordered={false} style={{ width: '100%' }}>
                                {
                                    this.state.fileslist.length === 0? <Empty></Empty>:
                                        this.state.fileslist.map(item=>{
                                            return <div onClick={()=>{this.downloads(item)}} className='new-block'>
                                                <a href={item.fileurl} style={{color:'rgba(0, 0, 0, 0.65)'}}>{item.title}</a >
                                                <label className='circle'>></label>
                                            </div>
                                        })
                                }
                            </Card>
                        </div>
                    </div>
                </div>
                <Modal title={this.state.title}
                       visible={this.state.isModalVisible}
                       onCancel={this.handleCanceldialog}
                       centered={true}
                       footer={[
                           <Button key="submit" type="primary" onClick={this.handleCanceldialog}>
                               取消
                           </Button>
                       ]}
                >
                    <div style={{marginTop:'-10px',textAlign:'center',marginBottom:'10px'}}><span style={{marginRight:'10px'}}>{this.state.name}</span><span>{this.state.time}</span></div>
                    <div style={{whiteSpace: 'pre-wrap'}}>{this.state.content}</div>
                </Modal>
            </main>
        )
    }
}

export default compose(withRouter)(Home);
